<!-- 产品介绍 -->
<template>
	<div class="product">
		<HNB active="产品介绍"></HNB>
		<div class="banner-container">
			<div class="banner animated fadeIn" v-for="(item,index) in posters" @click="know_more(index)"
				v-show="index==bannernum">
				<div class="banner-box" v-if="item.is_banner==1">
					<div class="banner-title">
						<div class="banner-title-box animated fadeInUp" :style="bannerTitleBoxBg">
							<span class="banner-title-content-h1">{{item.lf_func_lefan_product[0].product_name}}</span>
							<span class="banner-title-content-h2">{{item.lf_func_lefan_product[0].desc}}</span>
							<span class="banner-title-content-link">{{know}}</span>
						</div>
					</div>
					<div class="banner-image animated fadeInUp">
						<img v-if="!item.is_banner" :src="lf_func_lefan_product[0].product_honor_img"
							class="swiper-honor-img" />
						<div class="banner-image-box">
							<img :src="item.swiper_img" />
						</div>
					</div>
				</div>
				<div v-else class="banner-box">
					<img :src="item.swiper_img" />
				</div>
			</div>
		</div>

		<ListTitle @active="getMag" :active='activename' :list-data="listData"></ListTitle>
		<div style="min-height: 800px;">
			<div class="list-box">
				<transition-group name="fade">
					<div :key="condition">
						<div class="list-item" style="position: relative;"
							v-show="(condition == item.condition) && listItem" v-for="(item,i) in listItem" :key="i">
							<div class="item-left" style="margin-right: 3px;position: relative;"
								@click="playVideo(item,i)">
								<SvgIcon v-if="item.video_intro_link && !item.isPlay" class="svgicon"
									style="position: absolute;z-index: 99;top: 50%;left: 50%;transform: translate(-50%,-50%);cursor: pointer;"
									svg-name="playicon" size=50></SvgIcon>
								<video ref="videoRef" v-if="item.video_intro_link" @ended="endVideo(item,i)"
									width="600px" height="300px" :poster="item.product_use_img" style="object-fit:fill">
									<source :src="item.video_intro_link" type="video/mp4">
								</video>
								<div v-else>
									<img style="width: 600px;height: 300px;" :src="item.product_use_img" />
									<img :src="item.product_honor_img"
										style="position: absolute;left: 5%;top: 5%;width: 80px;">
								</div>
							</div>
							<div class="item-right"
								style="width: 500px;height: 300px;margin-left: 3px;cursor: pointer; background-color: #F1F1F1;margin-top: -7px;display: flex;align-items: center;justify-content: space-around;"
								@click="know_more_item(i)">
								<div class="info">
									<p style="color: #00C785;">进一步了解 ></p>
									<p class="info-title" v-if="item.product_name">{{item.product_name}}</p>
									<div class="info-detail" v-html="getFeatureStr(item.feature)"></div>
								</div>
								<img class="amplification_1_2" :src="item.product_img"
									style="display: block;width: 120px;height: 120px; height: 40%;" />
							</div>
						</div>
					</div>

				</transition-group>
			</div>
		</div>

		<BS :BsTitle="bsTitle"></BS>
		<PopUp v-if="popUp" @clickBac="clickBac" :productHtml="popHtml" :sampleName="sampleName"></PopUp>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import Banner from '../components/Banner.vue'
	import ListTitle from '../components/product/listTitle.vue'
	import BS from '../components/bottomShow.vue'
	import PopUp from '../components/LFPopUp.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	// import axios from 'axios'
	import request from '../common/request.js'

	export default {
		name: 'index',
		data() {
			return {
				popUp: false,
				sampleName: '',
				bannerTitleBoxBg: 'background-image: url(' + this.GLOBAL.imgHost + '/images/lf-bg.png);',
				bannernum: '',
				bsTitle: ['产品介绍', '生活更舒适'],
				posters: [],
				know: '进一步了解',
				listData: [{
					name: '生活更舒适',
					item: [],
				}, {
					name: '出行更轻松',
					item: [],
				}, {
					name: '办公新姿势',
					item: [],
				}],
				listItem: [],
				activename: '生活更舒适',
				condition: 1,
				popHtml: '',
				// currentIdxs: [],
				// isPlay: false,
				// isEnd: true
			};
		},
		computed: {
			getFeatureStr() {
				return function(featureArr) {
					let featureStr = ''
					featureArr.forEach((item, index) => {
						if ((index + 1) % 2 == 0) {
							featureStr += item + '</br>'
						} else if (index == featureArr.length - 1) {
							featureStr += item + ''
						} else {
							featureStr += item + '|'
						}
					})
					return featureStr
				}
			}
		},
		async created() {
			let that = this;
			await that.getSwiperList()
			await that.getProductIntroList()
			this.activename = this.$route.query.bottomname || '生活更舒适';
		},
		mounted() {
			this.play()
		},
		components: {
			HNB,
			Banner,
			ListTitle,
			BS,
			PopUp,
			SvgIcon
		},
		methods: {
			// 打开产品站(链接形式)
			openProduct(item) {
				let routeUrl = this.$router.resolve({
					path: "/productPage",
					query: {
						id: item._id
					}
				});
				window.open(routeUrl.href, '_blank');

			},
			playVideo(item, idx) {
				if (item.video_intro_link && !item.isPlay) {
					item.isPlay = true
					let index = this.$refs.videoRef.findIndex((i) => {
						return i.currentSrc == item.video_intro_link
					})
					this.$refs.videoRef[index].play()
				} else if (item.video_intro_link && item.isPlay) {
					let index = this.$refs.videoRef.findIndex((i) => {
						return i.currentSrc == item.video_intro_link
					})
					this.$refs.videoRef[index].pause()
					item.isPlay = false
				}
			},
			endVideo(item, idx) {
				item.isPlay = false
				// this.currentIdxs.splice(idx,1)
				let index = this.$refs.videoRef.findIndex((i) => {
					return i.currentSrc == item.video_intro_link
				})
				this.$refs.videoRef[index].load()
			},
			htmlEscape(str) {
				var temp = "";
				if (str.length == 0) return "";
				temp = str.replace(/&amp;/g, "&");
				temp = temp.replace(/&lt;/g, "<");
				temp = temp.replace(/&gt;/g, ">");
				temp = temp.replace(/&nbsp;/g, " ");
				temp = temp.replace(/&#39;/g, "\'");
				temp = temp.replace(/&quot;/g, "\"");
				return temp;
			},
			// 获取轮播图
			async getSwiperList() {
				// let res = await this.$Cloud.table(`lf_func_lefan_swiper`).where({link_table_array:['swiper']}).get({ page: 0, pageSize: 1000 })
				let res = await this.$Cloud
					.table(`lf_func_lefan_swiper`)
					.where({
						link_table_array: ['swiper']
					})
					.get({
						page: 0,
						pageSize: 1000
					})

				const {
					code,
					data
				} = res

				if (code == 200) {
					this.posters = data.filter(item => {
						return item.web_type == 1 && item.is_check == 2
					})
					console.log('获取轮播图123', this.posters)
				}


				// request.uniRequest('/swiper/getSwiperList')
				// 	.then(res => {
				// 		this.posters = res.data.filter(item => item.web_type == 0)
				// 		// console.log('0910----',this.posters)
				// 	}).catch(e => {})
				// let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ page: 0, pageSize: 1000 })

				// console.log('获取新闻列表',res)

				// const {code,data} = res
				// if(code == 200) {
				// 	this.news = data.filter(item=>item.is_check==2)
				// }


			},
			// 获取产品列表
			async getProductIntroList() {
				// 获取数据
				// request.uniRequest('/product/getProductIntroByCon', {

				let res = await this.$Cloud.table(`lf_func_lefan_product`).where({
					condition: this.condition
				}).get({
					page: 0,
					pageSize: 1000,
					sort_by: 'weight',
					order_by: 'desc'
				})

				const {
					code,
					data
				} = res

				if (code == 200) {
					this.listItem = data
					this.listItem.map(item => {
						this.$set(item, "isPlay", false)
					})
				}

				console.log('获取商品列表123', res)

				// request.uniRequest('/product/getProductList', {
				// 		params: {
				// 			condition: this.condition
				// 		}
				// 	})
				// 	.then(res => {
				// 		console.log('获取商品列表====>>>>',res)
				// 		this.listItem = res.data
				// 		// console.log('0910',this.listItem)
				// 		this.listItem.map(item => {
				// 			this.$set(item, "isPlay", false)
				// 		})
				// 	}).catch(e => {})

			},
			autoplay() {
				this.bannernum++
				if (this.bannernum == this.posters.length) {
					this.bannernum = 0
				}
			},
			play() {
				setInterval(this.autoplay, 6000)
			},
			getMag(e) {

				let that = this;
				that.bsTitle = ['产品介绍', e];

				for (let s of that.listData) {
					if (e == s.name) {
						that.listItem = s.item;
						that.activename = e
					}
				}

				// 设置condition的值，切换获取对应数据
				switch (e) {
					case '生活更舒适':
						that.condition = 1

						break
					case '出行更轻松':
						that.condition = 2

						break
					case '办公新姿势':
						that.condition = 3
				}
				that.getProductIntroList()
			},
			// 轮播图获取产品站图片
			know_more(e) {
				this.popHtml = this.posters[e].lf_func_lefan_product[0].product_html
				document.body.style.overflow = 'hidden';
				// this.sampleName = e;
				this.popUp = true;
			},
			// 点击产品获取产品站图片
			know_more_item(index) {
				this.popHtml = this.listItem[index].product_html

				document.body.style.overflow = 'hidden';
				this.popUp = true;

			},
			clickBac() {
				this.popUp = false;
				document.body.style.overflow = 'auto';
			}
		}
	}
</script>

<style scoped>
	@import url("../common/animate.min.css");

	.fade-enter {
		opacity: 0;
		transform: translateX(1024px);
	}

	.fade-enter-active {
		transition: all 1s;
	}

	.fade-enter-to,
	.fade-leave {
		transform: translateX(0);
		opacity: 1;
	}

	.fade-leave-active {
		transition: all 1s;
	}

	.fade-leave-to {
		transform: translateX(-1024px);
		opacity: 0;
	}

	.product .banner {
		padding-top: 200px;
		padding-bottom: 0%;
		cursor: pointer;
		padding-bottom: 80px;
		overflow: hidden;
	}


	.list-box {
		width: 1024px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 50px;
		background-color: #FFFFFF;
		min-height: 800px;
		overflow: hidden;
		position: relative;
	}

	.list-item {
		position: relative;
		width: 100%;
		max-width: 1024px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 30px;
	}

	.list-item img {
		width: 100%;
	}

	.item-right {
		position: relative;
		top: 0;
		left: 0;
	}

	.item-right .info {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.info-title {
		font-family: Alibaba-PuHuiTi-M;
		margin-top: 30px;
		font-size: 17px;
		font-weight: 600;
	}

	.info-detail {
		font-size: 12px;
		color: #5f5b5b;
		line-height: 20px;
		padding-top: 25px;
	}

	.info-detail2 {
		font-size: 12px;
		color: #5f5b5b;
		line-height: 20px;
		/* padding-top: 25px; */
	}

	.product .swiper-honor-img {
		width: 80px;
		position: absolute;
		right: 0;
		top: 0;
	}

	.banner-container {
		height: 625px;
		width: 100%;
		background-color: #FFFFFF;
	}
</style>
